export default __webpack_public_path__ + "static/media/mximg5.c07b49d1.webp";